import React from 'react';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const SportCategories = () => {


  const featuredPlans = [
    {
      title: "Burn Fat Cardio Sessions",
      image: "/path/to/cardio-image.jpg"
    },
    {
      title: "Big 5: Best Bodyweight Compound Exercises",
      image: "/path/to/bodyweight-image.jpg"
    },
    {
      title: "Strong Body Program 4",
      image: "/path/to/strong-body-image.jpg"
    }
  ];

  return (
    <>
     <Container  style={{ Width: "1000px", height: "650px" }}  className="my-5 mx-5">

      <h1 className="mb-3">JEFIT Workout Routine Database</h1>
      <p className="lead mb-5">
        Explore our extensive collection of workout plans and routines tailored to your fitness goals.
        Find the perfect routine to elevate your workout experience.
      </p>

      <h2 className="mb-4">Featured plans for you</h2>
      <p className="text-muted mb-4">Try one of these professionally designed workout plans</p>

      <Carousel 
          indicators={true}
          interval={null}  
          controls={true}
            pause="hover"
            style={{ height: "700px", width: "200%" }}
         // interval={500}
          className="mb-5 w-100"
        >
          {featuredPlans.map((plan, index) => (
            <Carousel.Item key={index}>
              <Card className="bg-dark text-white">
                <Card.Img src={plan.image} alt={plan.title}  style={{ height: "700px", width: "100%", objectFit: "cover" }}  />
                <Card.ImgOverlay className="d-flex align-items-end">
                  <Card.Title className="w-100 bg-primary-light bg-opacity-75 p-3 mb-0">
                    {plan.title}
                  </Card.Title>
                </Card.ImgOverlay>
              </Card>
            </Carousel.Item>
          ))}
        </Carousel>
     </Container>
   


     </>
   )
}


export default SportCategories;